window.addEventListener('DOMContentLoaded', e => {
    const trainingInput = document.querySelector('[name="training-name"]');
    if(trainingInput) {
        trainingInput.value = document.querySelector('.training-name').textContent
    }
})
